export const SEMINAR_IMAGES = [
    { src: 'assets/seminars/seminar_1.jpg', alt: 'Seminar Image 1' },
    { src: 'assets/seminars/seminar_3.jpg', alt: 'Seminar Image 3' },
    { src: 'assets/seminars/seminar_4.jpg', alt: 'Seminar Image 4' },
    { src: 'assets/seminars/seminar_5.jpg', alt: 'Seminar Image 5' },
    { src: 'assets/seminars/seminar_6.jpg', alt: 'Seminar Image 6' },
    { src: 'assets/seminars/seminar_7.jpg', alt: 'Seminar Image 7' },
    { src: 'assets/seminars/seminar_8.jpg', alt: 'Seminar Image 8' },
    { src: 'assets/seminars/seminar_9.jpg', alt: 'Seminar Image 9' },
    { src: 'assets/seminars/seminar_10.jpg', alt: 'Seminar Image 10' },
    { src: 'assets/seminars/seminar_11.jpg', alt: 'Seminar Image 11' },
    { src: 'assets/seminars/seminar_12.jpg', alt: 'Seminar Image 12' },
    { src: 'assets/seminars/seminar_13.jpg', alt: 'Seminar Image 13' },
    { src: 'assets/seminars/seminar_14.jpg', alt: 'Seminar Image 14' },
    { src: 'assets/seminars/seminar_15.jpg', alt: 'Seminar Image 15' },
    { src: 'assets/seminars/seminar_16.jpg', alt: 'Seminar Image 16' },
    { src: 'assets/seminars/seminar_17.jpg', alt: 'Seminar Image 17' },
    { src: 'assets/seminars/seminar_18.jpg', alt: 'Seminar Image 18' },
    { src: 'assets/seminars/seminar_19.jpg', alt: 'Seminar Image 19' },
    { src: 'assets/seminars/seminar_20.jpg', alt: 'Seminar Image 20' },
    { src: 'assets/seminars/seminar_21.jpg', alt: 'Seminar Image 21' },
    { src: 'assets/seminars/seminar_22.jpg', alt: 'Seminar Image 22' },
    { src: 'assets/seminars/seminar_23.jpg', alt: 'Seminar Image 23' },
    { src: 'assets/seminars/seminar_24.jpg', alt: 'Seminar Image 24' },
    { src: 'assets/seminars/seminar_25.jpg', alt: 'Seminar Image 25' },
    { src: 'assets/seminars/seminar_28.jpg', alt: 'Seminar Image 28' },
    { src: 'assets/seminars/seminar_29.jpg', alt: 'Seminar Image 29' },
    { src: 'assets/seminars/seminar_30.jpg', alt: 'Seminar Image 30' },
    { src: 'assets/seminars/seminar_31.jpg', alt: 'Seminar Image 31' },
    { src: 'assets/seminars/seminar_32.jpg', alt: 'Seminar Image 32' },
    { src: 'assets/seminars/seminar_33.jpg', alt: 'Seminar Image 33' },
    { src: 'assets/seminars/seminar_34.jpg', alt: 'Seminar Image 34' },
    { src: 'assets/seminars/seminar_35.jpg', alt: 'Seminar Image 35' },
    { src: 'assets/seminars/seminar_36.jpg', alt: 'Seminar Image 36' },
    { src: 'assets/seminars/seminar_37.jpg', alt: 'Seminar Image 37' },
    { src: 'assets/seminars/seminar_45.jpeg', alt: 'Seminar Image 45' },
    { src: 'assets/seminars/seminar_46.jpeg', alt: 'Seminar Image 46' },
    { src: 'assets/seminars/seminar_47.jpeg', alt: 'Seminar Image 47' },
    { src: 'assets/seminars/seminar_48.jpeg', alt: 'Seminar Image 48' }
];

export const FACILITY_IMAGES = [
    { src: 'assets/seminars/seminar_38.jpg', alt: 'Seminar Image 38' },
    { src: 'assets/seminars/seminar_39.jpg', alt: 'Seminar Image 39' },
    { src: 'assets/seminars/seminar_40.jpg', alt: 'Seminar Image 40' },
    { src: 'assets/seminars/seminar_41.jpg', alt: 'Seminar Image 41' },
    { src: 'assets/seminars/seminar_42.jpg', alt: 'Seminar Image 42' },
    { src: 'assets/seminars/seminar_43.jpg', alt: 'Seminar Image 43' },
    { src: 'assets/seminars/seminar_44.jpg', alt: 'Seminar Image 44' },
    { src: 'assets/facilities/facil_1.jpg', alt: 'Facility Image 1' },
    { src: 'assets/facilities/facil_2.jpg', alt: 'Facility Image 2' },
    { src: 'assets/facilities/facil_3.jpg', alt: 'Facility Image 3' },
    { src: 'assets/facilities/facil_4.jpg', alt: 'Facility Image 4' },
    { src: 'assets/facilities/facil_5.jpg', alt: 'Facility Image 5' },
    { src: 'assets/facilities/facil_6.jpg', alt: 'Facility Image 6' },
    { src: 'assets/facilities/facil_7.jpg', alt: 'Facility Image 7' },
    { src: 'assets/facilities/facil_8.jpg', alt: 'Facility Image 8' },
    { src: 'assets/facilities/facil_9.jpg', alt: 'Facility Image 9' },
    { src: 'assets/facilities/facil_10.jpg', alt: 'Facility Image 10' },
    { src: 'assets/facilities/facil_11.jpg', alt: 'Facility Image 11' },
];

export const AWARD_IMAGES = [
    { src: 'assets/awards/award_1.jpg', alt: 'AwardWinningTaeguTecDistributor' },
    { src: 'assets/awards/award_2.jpg', alt: 'AwardWinningMesserDistributor' },
    { src: 'assets/awards/award_3.jpg', alt: 'AwardWinningTaeguTecDistributor' },
    { src: 'assets/awards/award_4.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_5.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_6.jpg', alt: 'AwardWinningGrozDistributor' },
    { src: 'assets/awards/award_7.jpg', alt: 'AwardWinningGrozDistributor' },
    { src: 'assets/awards/award_8.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_9.jpg', alt: 'AwardWinningLtDistributor' },
    { src: 'assets/awards/award_10.jpg', alt: 'AwardWinningNonDestructiveTesting' },
    { src: 'assets/awards/award_11.jpg', alt: 'AwardWinningTaeguTecDistributor' },
    { src: 'assets/awards/award_12.jpg', alt: 'AwardWinningMesserDistributor' },
    { src: 'assets/awards/award_13.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_14.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_15.jpg', alt: 'AwardWinningTaeguTecDistributor' },
    { src: 'assets/awards/taegu-tech-certificate.jpg', alt: 'AwardWinningTaeguTecCertificate' },
    { src: 'assets/awards/award_16.jpg', alt: 'AwardWinningITWDistributor' },
    { src: 'assets/awards/award_17.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_18.jpg', alt: 'AwardWinningISNT' },
    { src: 'assets/awards/award_19.jpg', alt: 'AwardWinningLTDistributor' },
    { src: 'assets/awards/award_20.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_21.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_22.jpg', alt: 'AwardWinningEwacDistributor' },
    { src: 'assets/awards/award_23.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_24.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_25.jpg', alt: 'AwardWinningLTDistributor' },
    { src: 'assets/awards/award_26.jpg', alt: 'AwardWinningGrozDistributor' },
    { src: 'assets/awards/award_27.jpg', alt: 'AwardWinningSRGroup' },
    { src: 'assets/awards/award_28.jpg', alt: 'AwardWinningCastrolDistributor' },
    { src: 'assets/awards/award_29.jpg', alt: 'AwardWinningCastrolDistributor' },
]

export const SLIDE_IMAGES = [
    { src: 'assets/slide/award_1.webp', alt: 'Slide Image 1' },
    { src: 'assets/slide/award_2.webp', alt: 'Slide Image 2' },
    { src: 'assets/slide/award_3.webp', alt: 'Slide Image 3' },
    { src: 'assets/slide/award_4.webp', alt: 'Slide Image 4' },
    { src: 'assets/slide/award_5.webp', alt: 'Slide Image 5' },
    { src: 'assets/awards/taegu-tech-certificate.jpg', alt: 'Slide Image 6' },
    { src: 'assets/slide/sem_2.webp', alt: 'Slide Image 7' },
    { src: 'assets/slide/sem_3.webp', alt: 'Slide Image 8' },
    { src: 'assets/slide/sem_4.webp', alt: 'Slide Image 9' },
    { src: 'assets/slide/fac_1.webp', alt: 'Slide Image 10' },
]